import { MobileAppBar } from "@/react/components/Layout/AppBar/MobileAppBar";
import { useIsLoadingAppData } from "@/react/hooks/useIsLoadingAppData";
import { useSpaceSlugFromUrl } from "@/react/hooks/useSpaceSlugFromUrl";
import { useSpacesContext } from "@circle-react/contexts";
import {
  isBasicPostsSpace,
  isEventsSpace,
} from "@circle-react/helpers/spaceHelpers";
import { SkeletonLoader } from "@circle-react-uikit/SkeletonLoader";
import { useIsAppBarVisible } from "../useIsAppBarVisible";

export const AppBar = () => {
  const slug = useSpaceSlugFromUrl();
  const spacesContext = useSpacesContext();

  const space = spacesContext.helpers.findBy({ slug });
  const isAppBarVisible = useIsAppBarVisible();
  const isLoadingAppData = useIsLoadingAppData();

  if (!isAppBarVisible) {
    return null;
  }

  if (isLoadingAppData) {
    return (
      <header className="header">
        <SkeletonLoader
          variant="app-bar"
          showMemberAvatarsRow={
            space ? isEventsSpace(space) || isBasicPostsSpace(space) : false
          }
        />
      </header>
    );
  }

  return <MobileAppBar />;
};
